import { useHistory, useLocation } from "react-router-dom";
import { Layout } from "../../../shared/components/Layout";
import { FormTaxProfile } from "../components/FormTaxProfile";
import { PATH_TAXES, PATH_TAXES_EDIT_TAX_RATE } from "../paths";

export const RouteEditTaxProfile = () => {
  const history = useHistory();
  const location = useLocation<{
    backPath?: string;
    nextPath?: string;
  }>();

  return (
    <Layout title="Tax Withholdings">
      <FormTaxProfile
        onBack={() => {
          history.push(location.state?.backPath || PATH_TAXES);
        }}
        onNext={() => {
          history.push(location.state?.nextPath || PATH_TAXES_EDIT_TAX_RATE);
        }}
        isEdit
      />
    </Layout>
  );
};
